import React, { Fragment, useMemo } from 'react';
import { Button, Card, Col, Form, Icon, InputNumber, message, Result, Row, Table, Tag } from 'antd';
import * as CommonService from '../../../../../services/CommonService';
import { currencyVND, formatCurrency, parserNumber } from '../../../../../utils';
import SelectIMEI from './SelectIMEI';
import InfoRow from '../../../../../components/common/info-row';
import { PRODUCT_ENDPOINT } from '../../../../../services/endpoint';
import SelectInfinitePro from '../../../../../components/common/select-infinite-pro';

let currIdx = -1;

const ReplaceProduct = (props) => {

  const [visible, setVisible] = React.useState(false);
  const [curProduct, setCurProduct] = React.useState({});
  const [discount, setDiscount] = React.useState(0);
  const { ds, setDs, setTotalPrice } = props;


  const handleSelect = async (value) => {
    if (value) {
      if (ds?.some(el => el.id === value.value)) {
        message.error('Bạn đã chọn sản phẩm này rồi');
        return;
      }
      await getPurchaseDetailById(value.value);
    }
  };

  const getPurchaseDetailById = async (id) => {
    try {
      window.setLoading(true);
      const response = await CommonService.findById(PRODUCT_ENDPOINT, id);
      const data = response.data || {};
      data.imeiList = data.imeiResponseList?.filter(i => i.status !== -1) || [];
      data.totalProduct = data.isNormal ? data.quantity : data.imeiList.length;
      setDs([...ds, data]);
    } catch (error) {
      message.error(error?.data?.message);
    } finally {
      window.setLoading(false);
    }
  };

  const renderOptions = data => {
    const el = data.data;
    const quantity = el.isNormal ? el.stockQuantity : el.imeiResponseList?.filter(i => i.status === 0)?.length || 0;
    return <Row>
      <Col span={20}>
        <b>{el.name}</b>
      </Col>
      <Col span={4} style={{ textAlign: 'right' }}>
        Giá nhập: {currencyVND(el.retailPrice)}
      </Col>
      <Col span={20}>
        <i>{el.code} | {el.isNormal ? 'Sản phẩm thường' : 'Serial/IMEI'}</i>
      </Col>
      <Col span={4} style={{ textAlign: 'right' }}>
        Tồn: {<span style={{ color: quantity === 0 ? 'red' : 'blue' }}>{quantity}</span>}
        {/*| Có thể bán: 100*/}
      </Col>
    </Row>;
  };

  const handleSelectImei = (imeiList) => {
    const product = ds[currIdx];
    product.imeiListSelected = imeiList;
    product.countProduct = imeiList.length;
    setDs([...ds]);
  };

  const getTotalPrice = useMemo(() => {
    const total = ds.reduce((sum, item) => sum + (((item?.countProduct || 0) * item?.retailPrice) - (item?.discount || 0)), 0);
    const result = total > 0 ? total - discount : total;
    setTotalPrice(result);
    return result;
  }, [ds, discount]);

  const columns = [
		{
			title: 'Thao tác',
			width: 90,
			align: 'center',
			render: (record, val, index) => <Button type={'link'} style={{ padding: 0 }}
																							onClick={() => onRemove(index)}>X</Button>
		},
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
      width: 60,
      render: (text, record, index) => index + 1
    },
    {
      title: 'Mã sản phẩm',
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      width: 150,
      render: (code, record) => <Fragment>
        <Row gutter={12} style={{ marginTop: 10 }}>
          <Col>
            <Button type="link" onClick={() => {
              window.open(`/product/${record.id}`);
            }}>{code}</Button>
          </Col>
        </Row>
      </Fragment>
    },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'name',
      width: 200
    },
    {
      title: 'Phân Loại',
      dataIndex: 'isNormal',
      key: 'isNormal',
      align: 'center',
      width: 150,
      render: (isNormal) => {
        return isNormal ? <Tag style={{ width: '110px' }} color="magenta">Sản phẩm thường</Tag> :
          <Tag style={{ width: '110px' }} color="green">Serial/IMEI</Tag>;
      }
    },
    {
      title: 'Số lượng',
      width: 200,
      align: 'center',
      render: (text, record, idx) => {
        const quantity = record.isNormal ? record.stockQuantity : record.imeiResponseList?.filter(i => i.status === 0).length || 0;
        return <Fragment>
          {record.isNormal ? <InputNumber
            style={{ width: '50%' }}
            formatter={formatCurrency}
            parser={parserNumber} defaultValue={0} min={0}
            value={record?.countProduct || 0}
            onChange={value => {
              record.countProduct = value;
              setDs([...ds]);
            }} max={quantity} /> : record?.countProduct || 0} / {formatCurrency(quantity)}
          {!record.isNormal && <Fragment><br />
            <Button type={'link'} onClick={() => {
              setCurProduct(record);
              setVisible(true);
              currIdx = idx;
            }}> <span style={{ fontSize: '12px' }}>Xem/Chọn IMEI</span></Button></Fragment>}
        </Fragment>;
      }
    },
    {
      title: 'Đơn giá',
      width: 150,
      align: 'center',
      render: (text, record) => <Fragment>
        <InputNumber formatter={formatCurrency}
                     style={{ width: '100%' }}
                     parser={parserNumber} defaultValue={0} min={0}
                     value={record?.retailPrice || 0}
                     onChange={value => {
                       record.retailPrice = value;
                       setDs([...ds]);
                     }} />
      </Fragment>
    },
    {
      title: 'Chiết khấu',
      width: 150,
      align: 'center',
      render: (text, record) => <Fragment>
        <InputNumber formatter={formatCurrency}
                     style={{ width: '100%' }}
                     parser={parserNumber} defaultValue={0} min={0}
                     value={record?.discount || 0}
                     onChange={value => {
                       record.discount = value;
                       setDs([...ds]);
                     }} />
      </Fragment>
    },
    {
      title: 'Thành tiền',
      width: 200,
      align: 'center',
      render: (item) => currencyVND(item?.countProduct > 0 ? (((item?.countProduct || 0) * item?.retailPrice) - (item?.discount || 0)) : 0)
    },
  ];

  const onRemove = (idx) => {
    const newDs = [...ds];
    newDs.splice(idx, 1); // Xoá phần tử tại vị trí idx
    setDs(newDs);
  };

  const renderFooter = () => {
    return <Fragment>
      <InfoRow labelSpan={3} valueSpan={16} label={'Số lượng đổi'}
               value={`${ds.reduce((sum, item) => sum + (item?.countProduct || 0), 0)} sản phẩm`} />
      {/*<InfoRow labelSpan={3} valueSpan={16} label={'Chiết khấu'} value={<><InputNumber formatter={formatCurrency}*/}
      {/*                                                                               style={{ width: '20%' }}*/}
      {/*                                                                               parser={parserNumber}*/}
      {/*                                                                               defaultValue={0} min={0}*/}
      {/*                                                                               value={discount}*/}
      {/*                                                                               onChange={value => {*/}
      {/*                                                                                 setDiscount(value);*/}
      {/*                                                                               }} /> VND</>}  />*/}
      <InfoRow labelSpan={3} valueSpan={16} label={<>Khách phải trả</>}
               value={<span
                 style={{ color: 'red' }}>{currencyVND(getTotalPrice)} </span>} />
    </Fragment>;
  };

  return (<Fragment>
    <Form layout={'vertical'} className={'mt-20 refund-product-create-page'}>
      <Card title={'Đổi hàng'}>
        <SelectInfinitePro endpoint={PRODUCT_ENDPOINT}
                           endpointParam={{ allowSell: true }}
                           handleSelect={handleSelect}
                           placeholder={'Tìm theo tên, mã...'}
                           customOption={renderOptions}
                           value={null}
        />
        {ds.length > 0 ? <>
          <Table columns={columns}
                 dataSource={ds}
                 pagination={false}
                 rowKey={record => record.id}
          />
          <Col className={'mt-20'}>
            <Row>
              <Col>
                {renderFooter()}
              </Col>
              {/*<Col span={16}>*/}
              {/*  <Form.Item label={'Ghi chú đơn hàng'}>*/}
              {/*    {props.form.getFieldDecorator('reason', {})(<TextArea placeholder={'Nhập ghi chú đơn hàng'}*/}
              {/*                                                          rows={3} />)}*/}
              {/*  </Form.Item>*/}
              {/*</Col>*/}
            </Row>
          </Col></> : <><Card className={'mt-20'}>
          <Result
            icon={<Icon type="inbox" />}
            subTitle="Chưa có thông tin sản phẩm"
          />
        </Card>
        </>}
        <SelectIMEI visible={visible} setVisible={setVisible} curProduct={curProduct}
                    handleSelectImei={handleSelectImei} />
      </Card>
    </Form>
  </Fragment>);
};
export default ReplaceProduct;
